export const devLog = (...args) => {
  if (
    process.env.NODE_ENV !== "production" &&
    typeof console !== "undefined" &&
    typeof console.log === "function"
  ) {
    console.log(...args);
  }
};

export const devDebug = (...args) => {
  if (
    process.env.NODE_ENV !== "production" &&
    typeof console !== "undefined" &&
    typeof console.debug === "function"
  ) {
    console.debug(...args);
  }
};
